import { render, staticRenderFns } from "./StokEkstre.vue?vue&type=template&id=309e20dc&"
import script from "./StokEkstre.vue?vue&type=script&lang=js&"
export * from "./StokEkstre.vue?vue&type=script&lang=js&"
import style0 from "./StokEkstre.vue?vue&type=style&index=0&id=309e20dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports